import React, { useState, useEffect, useCallback } from 'react';
import { 
    Typography, Paper, TextField, IconButton, Snackbar, Alert, Dialog,
    DialogTitle, DialogContent, DialogActions, Table, TableHead, TableBody,
    TableRow, TableCell, Box, Button, Radio, RadioGroup, FormControlLabel, FormControl
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useRef } from "react";
import { AllCommunityModule } from 'ag-grid-community'; 
import { AgGridReact } from 'ag-grid-react';
import Draggable from 'react-draggable';
import img from "../../assets/img/spinner.svg";

// Iconos
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CompareIcon from '@mui/icons-material/Compare';
import DeleteIcon from '@mui/icons-material/Delete';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import VisibilityIcon from "@mui/icons-material/Visibility";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import CollectionsIcon from '@mui/icons-material/Collections';

import CrearEditarModal from './modales/CrearEditarOxxo';
import GalleryDialog from './modales/GalleryDialog';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
}

const Cargas_Oxxo = () => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const gridRef = useRef();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [unit, setUnit] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
    const [updateType, setUpdateType] = useState('dia');
    const [selectedMonth, setSelectedMonth] = useState(null);

    const handleChangeUnidad = (event) => setUnit(event.target.value);

    const handleChangeStartDate = (newValue) => {
        setStartDate(newValue);
        if (endDate && newValue.isAfter(endDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha inicial no puede ser mayor que la fecha final.',
            }).then(() => setEndDate(newValue)); 
        }
    };

    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
        if (startDate && newValue.isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha final no puede ser menor que la fecha inicial.',
            }).then(() => setEndDate(startDate)); 
        }
    };

    const handleClearDate = (fecha) => {
        if(fecha === 'fi') setStartDate(null); 
        else if (fecha === 'ff') setEndDate(null); 
    };

    const formatDate = (date) => {
        if (!date) return ""; 
        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false,
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
        const [datePart, timePart] = formattedDate.split(', ');
        const [month, day, year] = datePart.split('/');
        return `${month}/${day}/${year} ${timePart}`;
    };

    const [selectedRow, setSelectedRow] = useState(null);
    const [openGallery, setOpenGallery] = useState(false);
    
    const handleCloseGallery = () => {
        setOpenGallery(false);
        setSelectedRow(null);
    };

    const renderizarDialogGaleria = (row) => {
        let rutas = [];
        try {
            rutas = typeof row.fotos === 'string' ? JSON.parse(row.fotos) : row.fotos;
        } catch (e) {
            console.warn("No se pudo convertir rutas_fotos a array:", e);
            rutas = [];
        }

        if (!Array.isArray(rutas)) rutas = [rutas];

        const rutasValidas = rutas.filter(f =>
            f && typeof f === 'object' && typeof f.ruta === 'string' && f.ruta.trim() !== ''
        );

        if (rutasValidas.length === 0) {
            Swal.fire("Sin imágenes", "Esta unidad no tiene imágenes disponibles.", "info");
            return;
        }

        setSelectedRow({ ...row, rutas_fotos: rutasValidas });
        setOpenGallery(true);
    }; 

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const handleCloseSnackbar = (event, reason) => {
      if (reason === 'clickaway') return;
      setSnackbarOpen(false);
    };

    const [openSeparaciones, setOpenSeparaciones] = useState(false);
    const [rowSeleccionado, setRowSeleccionado] = useState(null);
    const [separaciones, setSeparaciones] = useState([]);

    const handleVerSeparaciones = async (row) => {
        setRowSeleccionado(row);
        setOpenSeparaciones(true);
        try {
            const resp = await myApi.get(`/cargasFuel/oxxo/separaciones/${row.folioUnico}`);
            if (resp.data.success) setSeparaciones(resp.data.data);
            else setSeparaciones([]);
        } catch (error) {
            console.error(error);
            setSeparaciones([]);
        }
    };

    const handleVerMovimientos = async (row) => {
        setRowSeleccionado(row);
        setOpenSeparaciones(true);
        try {
            const resp = await myApi.get(`/cargasFuel/oxxo/movimientos/${row.folioUnico}`);
            if (resp.data.success) setSeparaciones(resp.data.data);
            else setSeparaciones([]);
        } catch (error) {
            console.error(error);
            setSeparaciones([]);
        }
    };

    const handleDelete = useCallback(async (id) => {
        try {
            Swal.fire({
                title: '¿Está seguro de eliminar esta carga?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/deleteOxxo/${id}`);
                    if (data.success) {
                        Swal.fire({ icon: 'success', title: 'Carga eliminada' });
                        setData(prevData => prevData.filter(carga => carga.id !== id));
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error al eliminar la carga' });
                    }
                }
            });
        } catch (error) {
            console.error('Error deleting fuel up:', error);
        }
    }, []);

    const handleDeleteSep = useCallback(async (row) => {
        try {
            Swal.fire({
                title: '¿Está seguro de eliminar estas separaciones?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/oxxo/deleteSep/${row.folioUnico}`);
                    if (data.success) {
                        Swal.fire({ icon: 'success', title: 'Separaciones eliminadas' });
                        fetch();
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error al eliminar la separación' });
                    }
                }
            });
        } catch (error) {
            console.error('Error deleting fuel up:', error);
        }
    }, []);

    const handleDeleteMov = useCallback(async (row) => {
        try {
            Swal.fire({
                title: '¿Está seguro de eliminar este movimiento?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/oxxo/deleteMov/${row.folioUnico}`);
                    if (data.success) {
                        Swal.fire({ icon: 'success', title: 'Movimiento eliminado' });
                        fetch();
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error al eliminar el movimiento' });
                    }
                }
            });
        } catch (error) {
            console.error('Error deleting fuel up:', error);
        }
    }, []);

    const handleUpdate = async () => {
        if (updateType === 'mes' && !selectedMonth) {
            Swal.fire({ icon: 'warning', title: 'Selecciona un mes' });
            return;
        }

        let url = '/cargasFuel/uploadOxxo';
        if (updateType === 'mes') {
            const fechaInicial = selectedMonth.startOf('month').format('YYYY-MM-DD');
            const fechaFinal = selectedMonth.endOf('month').format('YYYY-MM-DD');
            url = `/cargasFuel/uploadOxxo?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`;
        }

        setOpenUpdateDialog(false);
        Swal.fire({ icon: 'info', title: "Cargando...", allowOutsideClick: false, showConfirmButton: false });

        await myApi.get(url)
            .then((response) => {
                if (!response.data.success) throw new Error(response.data.message);
                Swal.fire({ icon: 'success', title: '¡Se actualizó correctamente!', text: response.data.message });
            })
            .catch((error) => {
                Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
            })
            .finally(() => { fetch(); });
    };

    const [open, setOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [isPdf, setIsPdf] = useState(false);
    const [isImage, setIsImage] = useState(false);
    const [Titulo, setTitulo] = useState('');

    const handleFileClick = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        const isPdfFile = extension === 'pdf';
        const isImageFile = ['jpg', 'jpeg', 'png', 'gif'].includes(extension);
        const mimeType = isPdfFile ? 'application/pdf' : isImageFile ? `image/${extension === 'jpg' ? 'jpeg' : extension}` : '';

        myApi.get(`fuel_report/pdf/${encodeURIComponent(fileName)}`, { responseType: 'arraybuffer' })
        .then((response) => {
            const blob = new Blob([response.data], { type: mimeType });
            const url = window.URL.createObjectURL(blob);
            setIsPdf(isPdfFile);
            setIsImage(isImageFile);
            setFileUrl(url);
            setOpen(true);
        })
        .catch((error) => { console.error('Error al cargar el PDF:', error); });
    };

    const handleOpenDialog = (params, isPdf = 1, nombre_col = '', titulo = '', numero = null) => {
        setTitulo(titulo);
        if(isPdf) handleFileClick(params.pdf);
    };

    const handleCloseDialog = () => setOpen(false);

    const normalizarFotosGrid = (fotos) => {
        if (!fotos) return [];
        let parsed = fotos;
        if (typeof fotos === 'string') {
            try { parsed = JSON.parse(fotos); } catch { return []; }
        }
        if (!Array.isArray(parsed)) parsed = [parsed];
        return parsed.filter(f => f && typeof f === 'object' && typeof f.ruta === 'string' && f.ruta.trim() !== '');
    };

    const columns = [
        {
            headerName: "PDF", headerTooltip: "PDF", width: 50, field: "pdf",
            filter: false, suppressMenu: true, suppressColumnsToolPanel: true,
            cellStyle: { textAlign: "center" }, pinned: true,
            cellRenderer: (params) => {
                const row = params.data;
                if(row && row.pdf) {
                    return (
                        <Box>
                            <BtnAcciones icon={<PictureAsPdfIcon />} label={'Abrir PDF'} onClick={() => handleOpenDialog(row, 1, null, 'PDF SUBIDO')} />
                        </Box>
                    );
                }
            }
        },
        {
            field: "fotos", headerName: "IMÁGENES", headerTooltip: "IMÁGENES", width: 50,
            filter: false, pinned: true,
            cellRenderer: (params) => {
                const fotosValidas = normalizarFotosGrid(params.data?.fotos);
                if (fotosValidas.length === 0) return null;
                return (
                    <BtnAcciones
                        icon={<CollectionsIcon />} label={`Ver (${fotosValidas.length})`}
                        onClick={() => renderizarDialogGaleria({ ...params.data, fotos: fotosValidas })}
                    />
                );
            }
        },
        { field: 'fecha', headerName: 'Fecha Histórica', cellStyle: { textAlign: "center" }, minWidth: 150, valueFormatter: (params) => formatDate(params.value), pinned: true },
        { field: 'noEconomico', headerName: 'No. Económico', cellStyle: { textAlign: "center" }, minWidth: 150, pinned: true },
        { field: 'cliente', headerName: 'Cliente', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'grupo', headerName: 'Grupo', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'noTransaccion', headerName: 'No. Transacción', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'noTarjeta', headerName: 'No. Tarjeta', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'placa', headerName: 'Placas', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'marca', headerName: 'Marca', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'modelo', headerName: 'Modelo', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'anioVeh', headerName: 'Año Vehículo', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'noEstacion', headerName: 'No. Estación', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'estacion', headerName: 'Estación', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'bomba', headerName: 'Bomba', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'odometro', headerName: 'Odómetro', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'producto', headerName: 'Producto', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { 
            field: 'consumoPesos', headerName: 'Consumo en Pesos', cellStyle: { textAlign: "right" }, minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue)) return params.value;  
                return `$${numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            }
        },
        { 
            field: 'consumoLitros', headerName: 'Consumo en Litros', cellStyle: { textAlign: "right" }, minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue)) return params.value;  
                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },
        { field: 'fechaFacturacion', headerName: 'Fecha de Facturación (CDMX)', cellStyle: { textAlign: "center" }, minWidth: 150, valueFormatter: (params) => formatDate(params.value) },
        { field: 'vin', headerName: 'VIN', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'orden', headerName: 'Orden', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'ubicacion', headerName: 'Ubicación', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'destino', headerName: 'Destino', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'nivelDiesel', headerName: 'Nivel de Diésel', cellStyle: { textAlign: "center" }, minWidth: 150 },
        {
            headerName: "Acciones", field: "actions", width: 150, sortable: false, filter: false, suppressMenu: true, suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const row = params.data;
                if (!row || row.isTotal) return null;
                
                if (row.separado > 0) {
                    return (
                        <div style={{ display: "flex", gap: 8 }}>
                            <BtnAcciones icon={<VisibilityIcon />} label="Ver separaciones" onClick={() => handleVerSeparaciones(row)} />
                            <BtnAcciones icon={<DeleteIcon />} label="Eliminar Separación" onClick={() => handleDeleteSep(row)} />
                        </div>
                    );
                }

                if (row.movido > 0) {
                    return (
                        <div style={{ display: "flex", gap: 8 }}>
                            <BtnAcciones icon={<VisibilityIcon />} label="Ver movimientos" onClick={() => handleVerMovimientos(row)} />
                            <BtnAcciones icon={<DeleteIcon />} label="Eliminar movimiento" onClick={() => handleDeleteMov(row)} />
                        </div>
                    );
                }

                if (row.isManual === "1") {
                    return (
                        <div style={{ display: "flex", gap: 8 }}>
                            <BtnAcciones icon={<BorderColorIcon />} label="Editar" onClick={() => handleEdit(row)} />
                            <BtnAcciones icon={<DeleteIcon />} label="Eliminar" onClick={() => handleDelete(row.id)} />
                        </div>
                    );
                }

                return (
                    <div style={{ display: "flex", gap: 8 }}>
                        <BtnAcciones icon={<CompareIcon />} label="Dividir" onClick={() => handleSplit(row)} />
                        <BtnAcciones icon={<TrendingFlatIcon />} label="Mover" onClick={() => handleMove(row)} />
                    </div>
                ); 
            },
        }
    ];

    const handleEdit = useCallback(async (fuelRow) => {
        handleOpenModal(data.find(carga => carga.id === fuelRow.id));
        setIsEditing(true);
        setSelected(fuelRow);
    }, [data]);

    const handleSplit = useCallback((fuelRow) => {
        const carga = data.find(carga => carga.id === fuelRow.id);
        handleOpenModal(carga, true, false);
    }, [data]);

    const handleMove = useCallback((fuelRow) => {
        const carga = data.find(carga => carga.id === fuelRow.id);
        handleOpenModal(carga, false, true);
    }, [data]);

    const fetch = async (unidad = null, fi = null, ff = null) => {
        setLoading(true);
        try {
            const datosEnviados = { unidad, fi, ff };
            const response = await myApi.post('/cargasFuel/getOxxo', datosEnviados);
            if(response.data.success) setData(response.data.data);
            else setData([]);
        } catch(error) {
            console.error('Error fetching fuel loads:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetch(); }, []);

    const handleSubmit = async () => {
        let fechainicial = null, fechafinal = null, unidad = null;
        if (startDate && startDate.$d !== 'Invalid Date') fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d !== 'Invalid Date') fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit !== 'undefined' && unit !== '') unidad = unit;
        await fetch(unidad, fechainicial, fechafinal);
    };

    const totalsRow = React.useMemo(() => {
        const sum = (field) => data.reduce((acc, row) => acc + (Number(row[field]) || 0), 0);
        return {
            id: 'totals',
            noEconomico: 'TOTAL',
            isTotal: true, 
            consumoPesos: sum('consumoPesos'),
            consumoLitros: sum('consumoLitros'),
        };
    }, [data]);

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isDividing, setIsDividing] = useState(false);
    const [isMoving, setIsMoving] = useState(false);

    const handleOpenModal = (carga = null, dividir = false, mover = false) => {
        setSelected(carga);
        setIsEditing(!dividir && !mover && !!carga);
        setIsDividing(dividir && !!carga);
        setIsMoving(mover && !!carga);
        setModalOpen(true);
    };

    const formatNumber = (value) => {
        const number = Number(value) || 0;
        return number.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        return number.toLocaleString("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 2 });
    };

    const handleExport = () => {
        const columnDefs = gridRef.current.api.getColumnDefs();
        const columnasAExportar = columnDefs
            .filter(col => col.field && !['fotos', 'pdf', 'actions'].includes(col.field))
            .map(col => col.field);

        gridRef.current.api.exportDataAsCsv({ columnKeys: columnasAExportar });
    };

    return (
    <>
        {/* Modal Separaciones */}
        <Dialog open={openSeparaciones} onClose={() => setOpenSeparaciones(false)} maxWidth="md" fullWidth>
            <DialogTitle>Folio {rowSeleccionado?.folioUnico}</DialogTitle>
            <DialogContent>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>CLIENTE</TableCell>
                            <TableCell>GRUPO</TableCell>
                            <TableCell align="center">NO. ECONÓMICO</TableCell>
                            <TableCell align="right">CONSUMO EN LITROS</TableCell>
                            <TableCell align="right">CONSUMO EN PESOS</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {separaciones.map((sep) => (
                            <TableRow key={sep.id}>
                                <TableCell>{sep.cliente}</TableCell>
                                <TableCell>{sep.grupo}</TableCell>
                                <TableCell align="center">{sep.noEconomico}</TableCell>
                                <TableCell align="right">{formatNumber(sep.consumoLitros)}</TableCell>
                                <TableCell align="right">{formatCurrency(sep.consumoPesos)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenSeparaciones(false)}>Cerrar</Button>
            </DialogActions>
        </Dialog>

        {/* Modal Visualizador PDF/Imagen */}
        <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth sx={{
            "& .MuiDialogContent-root": { padding: 0 }
        }} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {Titulo}
            </DialogTitle>
            <DialogContent>
                {isPdf ? (
                    <object data={fileUrl} type="application/pdf" style={{ width: '100%', height: '500px' }}>
                        <p>Tu navegador no soporta la visualización de PDFs. Puedes <a href={fileUrl} target="_blank" rel="noopener noreferrer">ver el PDF aquí</a>.</p>
                    </object>
                ) : isImage ? (
                    <img src={fileUrl} alt="Imagen" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                ) : (
                    <p>Este archivo no es un PDF ni una imagen compatible.</p>
                )}
            </DialogContent>
        </Dialog>

        {/* Modal Actualización */}
        <Dialog open={openUpdateDialog} onClose={() => setOpenUpdateDialog(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Actualizar cargas OXXO</DialogTitle>
            <DialogContent>
                <FormControl sx={{ mt: 1 }}>
                    <RadioGroup value={updateType} onChange={(e) => setUpdateType(e.target.value)}>
                        <FormControlLabel value="dia" control={<Radio />} label="Actualizar día actual" />
                        <FormControlLabel value="mes" control={<Radio />} label="Actualizar mes completo" />
                    </RadioGroup>
                </FormControl>
                {updateType === 'mes' && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Mes a actualizar" views={['year', 'month']}
                            value={selectedMonth} onChange={(newValue) => setSelectedMonth(newValue)}
                            slotProps={{ textField: { fullWidth: true, sx: { mt: 2 } } }}
                        />
                    </LocalizationProvider>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenUpdateDialog(false)}>Cancelar</Button>
                <Button variant="contained" onClick={handleUpdate}>Actualizar</Button>
            </DialogActions>
        </Dialog>

        {/* Contenedor Principal Ajustado */}
        <Paper
            sx={{
                p: 2,
                height: "calc(100vh - 125px)",
                width: "100%",
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Grid container>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Typography variant="h4" fontWeight={700}>
                                Cargas de OXXO
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', gap: 1, justifyContent: isNonMobile ? 'flex-end' : 'start' }}>
                            <Button
                                variant="contained" startIcon={<BrowserUpdatedIcon />}
                                onClick={() => setOpenUpdateDialog(true)}
                                sx={{ backgroundColor: 'black', marginBottom: 1 }}
                            >
                                Actualizar
                            </Button>
                            <Button
                                variant="contained" startIcon={<AddCircleIcon />}
                                onClick={() => handleOpenModal()}
                                sx={{ backgroundColor: 'black', marginBottom: 1 }}
                            >
                                Agregar
                            </Button>
                        </Grid>
                        <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <TextField label="Unidad" variant="outlined" value={unit} onChange={handleChangeUnidad} fullWidth />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker value={startDate} onChange={handleChangeStartDate} format="MM/DD/YY" label="Fecha Inicial" slotProps={{ textField: { fullWidth: true } }} />
                                </LocalizationProvider>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker value={endDate} onChange={handleChangeEndDate} format="MM/DD/YY" label="Fecha Final" slotProps={{ textField: { fullWidth: true } }} />
                                </LocalizationProvider>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <Button
                                    type="button" color="inherit" onClick={handleSubmit} variant="contained"
                                    startIcon={<ManageSearchIcon />} sx={{ color: "primary", fontWeight: "bold" }}
                                >
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Box>

            {/* Grid de Datos */}
            <Box sx={{ flex: 1, minHeight: 0, mt: 1, display: "flex", flexDirection: "column" }}>
                <Box sx={{ flexShrink: 0, mb: 1 }}>
                    <Button variant="contained" onClick={handleExport} sx={{ width: 'auto', minWidth: 120 }}>
                        Exportar a Excel
                    </Button>
                </Box>

                <Box sx={{ flex: 1, minHeight: 0, width: "100%", position: "relative" }}>
                    {loading ? (
                        <Box sx={{ position: "absolute", inset: 0, zIndex: 10, display: "flex", justifyContent: "center", alignItems: "center", background: "rgba(255,255,255,0.6)" }}>
                            <img alt="Cargando..." width="120" height="120" src={img} style={{ borderRadius: "50%" }} />
                        </Box>
                    ) : (
                        <div className="ag-theme-quartz" style={{ height: "100%", width: "100%" }}>
                            <AgGridReact
                                modules={[AllCommunityModule]}
                                ref={gridRef}
                                rowData={data}
                                columnDefs={columns}
                                pagination={true}
                                pinnedBottomRowData={[totalsRow]}
                                getRowId={params => params.data.id}
                            />
                        </div>
                    )}
                </Box>
            </Box>
        </Paper>

        {/* Modal Crear/Editar */}
        <CrearEditarModal
            open={modalOpen} onClose={() => setModalOpen(false)}
            refresh={fetch} carga={selected}
            isEditing={isEditing} isDividing={isDividing} isMoving={isMoving}
        />

        {selectedRow && (
            <GalleryDialog
                open={openGallery} onClose={handleCloseGallery}
                fotos={selectedRow?.fotos || []}
            />
        )}

        <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
                Texto copiado al portapapeles ✅
            </Alert>
        </Snackbar>
    </>
    );
};

export default Cargas_Oxxo;